Ext.define('SA.lq.view.GridColumnEventHandler', {
    constructor({matchCol, clickCb}) {
        this.matchCol = matchCol;
        this.clickCb = clickCb;
    },

    onClick(grid, el, col) {
        if (!this.matchCol(col)) {
            return;
        }

        this.clickCb(col);
    },

    onMouseOut(grid, el, col) {
        if (!this.matchCol(col)) {
            return;
        }

        Ext.fly(el).removeCls('sa-grid-cell-over');
    },

    onMouseOver(grid, el, col) {
        if (!this.matchCol(col)) {
            return;
        }

        Ext.fly(el).addCls('sa-grid-cell-over');
    }
});